import { Component,OnInit } from '@angular/core';

import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as weekfinder from 'dayjs/plugin/weekOfYear';
import { environmentConfig } from '../../../../../environment';
import { HourglassService } from 'src/app/services/hourglass.service';

dayjs.extend(weekfinder);
dayjs.extend(tz);
dayjs.extend(utc);

@Component({
  selector: 'app-tab-send-weekly-update',
  templateUrl: './tab-send-weekly-update.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabSendWeeklyUpdateComponent implements OnInit {
  token!: string;
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');

  impersonatedUser: any = this.userID;
  listTimeWeeks: any[] = [];
  weeklyUpdate = {
    roadblocks: '',
    nextWeek: ''
  };
  gridFilters = {
    timeWeekKey: [dayjs(new Date()).year(), dayjs(new Date()).week()].join('_'),
    timeWeek: dayjs(new Date()).week(),
    timeYear: dayjs(new Date()).year()
  };
  errorMessage = "";
  reportTarget = 'iframe'; //(window.location.href.indexOf('localhost') > -1) ? 'window' : 'iframe';
  weekLabel = "";
  errorClass = "alert alert-danger p-2";
  errorText = "c_red";
  toAddress = "";
  listAddresses: any[] = [];
  previewEnabled = false;
  sendEnabled = false;

  constructor(
    private hourglassService: HourglassService
  ) { }


  ngOnInit(): void {
    const tokenuser: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(tokenuser).stsTokenManager.accessToken;
  }

  loadFromEntryTab(): void {
    this.hourglassService.getTimeEntryUxData(this.userID, "timeweeks", null,this.token).then(r => {
      this.listTimeWeeks = r.timeweeks;
      const def: any = this.listTimeWeeks[0];
      const tokenuser: any = sessionStorage.getItem("wOSUser");
      this.weekLabel = 'Week ' + def.wk + ': ' + def.wkstart + ' - ' + def.wkend;
      this.toAddress = JSON.parse(tokenuser).email;

      this.listAddresses.push(
        { "key": this.toAddress, "value": this.toAddress },
        { "key": "weekly@welara.com", "value": "weekly@welara.com" },
      )

      this.loadWeekData(null);
    })

    //const uinfo: any = sessionStorage.getItem("wOSUser");
    //this.listTimeWeeks = data.timeweeks;
    //const def: any = this.listTimeWeeks[0];
    //this.weekLabel = 'Week ' + def.wk + ': ' + def.wkstart + ' - ' + def.wkend;
    //this.toAddress = JSON.parse(uinfo).email;

    //this.listAddresses.push(
    //  { "key": this.toAddress, "value": this.toAddress },
    //  { "key": "weekly@welara.com", "value": "weekly@welara.com" },
    //)

    //this.loadWeekData(null);
  }


  loadWeekData(event: any): void {
    this.weekLabel = (event != null)  ? event.target.selectedOptions[0].text : this.weekLabel;
           
    const a = this.gridFilters.timeWeekKey.split('_');
    this.gridFilters.timeWeek = parseInt(a[1]);
    this.gridFilters.timeYear = parseInt(a[0]);

    this.hourglassService.loadWeeklyReportData(
      parseInt(this.userID),
      this.gridFilters.timeYear,
      this.gridFilters.timeWeek,
      this.token
    ).then(r => {
      const data = r[0];
      if (data !== undefined) {
        this.previewEnabled = true;
        this.sendEnabled = true;
        this.weeklyUpdate.roadblocks = data.txt_roadblocks;
        this.weeklyUpdate.nextWeek = data.txt_nextweek;
      } else {
        this.weeklyUpdate.roadblocks = "";
        this.weeklyUpdate.nextWeek = "";
        this.previewEnabled = false;
        this.sendEnabled = false;
      }
    })
  }


  saveComments(): void {

    if (this.weeklyUpdate.roadblocks.trim() == '') {
      this.errorMessage = "Roadblocks section is required.";
      $('#ta_roadblocks').trigger('focus');
      this.clearError();
      this.previewEnabled = false;
      this.sendEnabled = false;
      return;
    }

    if (this.weeklyUpdate.nextWeek.trim() == '') {
      this.errorMessage = "Next Week section is required.";
      $('#ta_nextweek').trigger('focus');
      this.clearError();
      this.previewEnabled = false;
      this.sendEnabled = false;
      return;
    }

    const json = {
      "userid": this.userID,
      "timeyr": this.gridFilters.timeYear,
      "timewk": this.gridFilters.timeWeek,
      "roadblocks": this.weeklyUpdate.roadblocks,
      "nextweek": this.weeklyUpdate.nextWeek
    }
    
    this.hourglassService.saveWeeklyNotes(json,this.token).then(r => {
      console.log("saveweeklynotes")
      this.previewEnabled = true;
      this.sendEnabled = true;
    })
  }

  downloadPreview() {
    const url = [
      environmentConfig.reportingUrl,
      "?uid=", this.userID,
      "&wk=", this.gridFilters.timeWeek,
      "&yr=", this.gridFilters.timeYear
    ].join('');
    if (window.location.href.indexOf('localhost') > -1)
      window.open(url, 'test', 'width=1000,height=800');
    else
      $('#weeklyFrame').attr('src', url);
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  clearError(): void {
    setTimeout(() => {
      this.errorMessage = "";
    },3000)
  }

  sendUpdate(): void {
    if (this.toAddress == "") {
      this.errorMessage = "To address can not be blank.  Please enter a valid email address to continue.";
      $('#to_address').trigger('focus');
      this.clearError();
      return;
    }


    const OSUser: any = sessionStorage.getItem("wOSUser");
    const obj = JSON.parse(OSUser);
    //const to = obj.email;
    
    const dates = this.weekLabel.split(': ')[1];
    const dtrange = dates.split(' - ');

    console.log(dtrange, this.weekLabel)
    const fromdt = dayjs(new Date(dtrange[0])).format("DDMMYYYY");
    const thrudt = dayjs(new Date(dtrange[1])).format("DDMMYYYY");
    console.log(fromdt,thrudt)
    const title = ["Welara","Weekly Update",obj.displayName,fromdt,thrudt].join(" - ");

    const answer = confirm("Your auto-generated weekly report will be e-mailed to you in the next few minutes from WelaraOS <qa-client@welara.com>.  Continue?")
    if (answer) {
      this.hourglassService.sendWeeklyEmail(
        encodeURIComponent(title),
        this.userID,
        this.gridFilters.timeWeek.toString(),
        this.gridFilters.timeYear.toString(),
        this.toAddress
      ).then(r => {
        if (r == 200) {
          this.errorClass = "alert alert-sm alert-success";
          this.errorText = "c_green"
          this.errorMessage = "Weekly generated successfully.  Check your email.";

          setTimeout(() => {
            this.errorClass = "alert alert-sm alert-danger";
            this.errorText = "c_red"
            this.errorMessage = "";
          }, 5000)

        }
      })
    }
  }
}
